import { Component, OnInit, OnDestroy, ViewChild, ElementRef, transition, Renderer2 } from '@angular/core';
import { Subscription } from "rxjs/Subscription";
import { VehicleService } from "../../../services/nonanon/vehicle/vehicle.service";
import { VehicleInfoService } from "../../../services/nonanon/vehicle/vehicle-info.service";
import { PersonInfoService } from '../../../services/nonanon/person/person-info.service';
import { AuthService } from '../../../services/auth/auth.service';


@Component({
  selector: 'app-vehicle',
  templateUrl: './vehicle.component.html'
})
export class VehicleComponent implements OnInit, OnDestroy {

  constructor(
    private vehicleService: VehicleService,
    private personInfoService: PersonInfoService,
    private authService: AuthService) {

  }

  @ViewChild('vehicleHTML') private vehicleHTML: ElementRef;

  onVehicleSearchResultsChanged: Subscription;
  onVehicleSearchResultsCleared: Subscription;
  onVehicleGettingInfo: Subscription;
  onPersonInfoChanged: Subscription;
  onPersonInfoChangedByAccessCode: Subscription;
  onSearchingDriver: Subscription;

  vehicleSearching = false;
  residentalSameAsMailing: boolean;
  residentalSameAsMailingResponseString: string = "";

  hasVehicleResult: number = 0;
  hasDriverResult: number = 0;
  hasAccessCodeResult: number = 0;
  loading: boolean = false;

  //security items
  canAccessVehicleSearch: boolean = false;
  canAccessDLSearch: boolean = false;
  canAccessCodeSearch: boolean = false;

  ngOnInit() {

    //Load security items for search view/right side wording
    this.canAccessVehicleSearch = this.authService.getUser().canAccessVehicleSearch;
    this.canAccessDLSearch = this.authService.getUser().canAccessDLSearch;
    this.canAccessCodeSearch = this.authService.getUser().canAccessCodeSearch;

    this.onVehicleSearchResultsChanged = this.vehicleService.vehicleSearchResultsChanged
      .subscribe(
        () => {
          if (this.vehicleService.getResponseInfo().isSuccess == true) {
            this.searchHasResult = true;
            this.hasDriverResult = 1;
          } else {
            this.vehicleService.getResponseInfo();
            this.hasVehicleResult = -1; // show error message for vehicle
            this.hasDriverResult = 1;   // hide search instructions info text
          }
        });

    this.onVehicleSearchResultsCleared = this.vehicleService.vehicleSearchResultsCleared
      .subscribe(
        () => {
          this.hasVehicleResult = 0;  // show search instructions info text
          this.hasDriverResult = 0;   // show search instructions info text
        });

    this.onVehicleGettingInfo = this.vehicleService.vehicleGettingInfo
      .subscribe(
        (r: boolean) => {
          this.vehicleSearching = r;
          this.loading = r;
        });

    this.onSearchingDriver = this.personInfoService.searchingDriver
      .subscribe(
        (r: boolean) => {
          this.vehicleSearching = r;
          this.loading = r;
        });

    this.onPersonInfoChanged = this.personInfoService.personInfoChanged
      .subscribe(
        () => {
          if (this.personInfoService.getResponseInfo().isSuccess == true) {
            this.searchHasResult = true;
            this.hasDriverResult = 1; // hide search instructions info text
          } else {
            this.hasVehicleResult = 1;  // hide search instructions info text
            this.hasDriverResult = -1;  // show error message for driver
          }
        });

    this.onPersonInfoChangedByAccessCode = this.personInfoService.personInfoChangedByAccessCode
      .subscribe(
        () => {
          if (this.personInfoService.getResponseInfoByAccessCode().isSuccess == true) {
            this.searchHasResult = true;
            this.hasAccessCodeResult = 1; // hide search instructions info text
          } else {
            this.hasVehicleResult = 1;  // hide search instructions info text
            this.hasAccessCodeResult = -1;  // show error message for driver
          }
        });
  }

  ngOnDestroy() {
    this.onVehicleSearchResultsChanged.unsubscribe();
    this.onVehicleSearchResultsCleared.unsubscribe();
    this.onVehicleGettingInfo.unsubscribe();
    this.onPersonInfoChanged.unsubscribe();
    this.onSearchingDriver.unsubscribe();
    this.onPersonInfoChangedByAccessCode.unsubscribe();
  }


  // show component depend on response from vehicle search form component when searching for vehicle or driver

  isVehicleSearch: boolean = false;
  isDriverSearch: boolean = false;
  isAccessCodeSearch: boolean = false;
  searchHasResult: boolean = false;

  showVehicleComponent() {
    return this.isVehicleSearch && this.searchHasResult;
  }

  showDriverComponent() {
    return this.isDriverSearch && this.searchHasResult && this.personInfoService.getResponseInfo().isSuccess;
  }

  showAccessCodeComponent() {
    return this.isAccessCodeSearch && this.searchHasResult; //&& this.personInfoService.getPersonInfoByAccessCode().isSuccess;
  }

}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/nonanon/vehicle/vehicle.component.ts